export const IS_DEV = process.env.REACT_APP_IS_DEV === '1' ? true : false
export default function consoleLogger(...args: any[]) {
  IS_DEV && console.log(...args)
}
